import HeaderMenuSignup from './HeaderMenuSignup'
import LogoLienHeader from './HeaderLogoLink'
import HeaderMenuSignin from './HeaderMenuSignin'
import HeaderMenuHelp from './HeaderMenuHelp'
import HeaderMenuProfile from './HeaderMenuProfile'
import HeaderMenuSearch from './HeaderMenuSearch'
import HeaderMenuChat from './HeaderMenuChat'
import HeaderMenuSignout from './HeaderMenuSignout'
import HeaderSign from './HeaderSign'
import HeaderRegistration from './HeaderRegistration'
import FooterMenusCooloc from './FooterMenusCooloc'
import FooterMenusAbout from './FooterMenusAbout'
import FooterMenusTools from './FooterMenusTools'
import FooterMenusApps from './FooterMenusApps'
import FooterMenusSocials from './FooterMenusSocials'
import FooterMenusPayments from './FooterMenusPayments'
import Select2 from './Select2'
import FcSlider from './FcSlider'
import FcSliderRange from './FcSliderRange'
import ProfilePicture from './ProfilePicture'
import HeaderUserInfo from './HeaderUserInfo'
import HeaderUserInfoRegistration from './HeaderUserInfoRegistration'
import DashboardSidebard from './DashboardSidebard'
import DashboardNewsletter from './DashboardNewsletter'
import HomeNewsletter from './HomeNewsletter'
import SimplePopup from './SimplePopup'
import PaymentPopup from './PaymentPopup'
import VuePassword from 'vue-password'
import ProfileCard from './ProfileCard'
import HeaderMenuBurgerMobile from './HeaderMenuBurgerMobile'
import MessagesHeader from './MessagesHeader'
import PushNotificationPopup from './PushNotificationPopup'

export default {
  HeaderMenuSignup,
  LogoLienHeader,
  HeaderMenuSignin,
  HeaderMenuHelp,
  Select2,
  HeaderSign,
  FooterMenusCooloc,
  FooterMenusAbout,
  FooterMenusTools,
  FooterMenusApps,
  FooterMenusSocials,
  FooterMenusPayments,
  HeaderMenuProfile,
  HeaderMenuSearch,
  HeaderMenuChat,
  HeaderMenuSignout,
  FcSlider,
  HeaderRegistration,
  FcSliderRange,
  DashboardSidebard,
  ProfilePicture,
  HeaderUserInfo,
  HeaderUserInfoRegistration,
  DashboardNewsletter,
  HomeNewsletter,
  SimplePopup,
  VuePassword,
  ProfileCard,
  HeaderMenuBurgerMobile,
  MessagesHeader,
  PaymentPopup,
  PushNotificationPopup,
}
